<script>
    const apiConfig = {
        //authBaseURI: 'http://localhost:8000/api-v1/auth',
        //appBaseURI: 'http://localhost:8000/api-v1/web-api/pos',
        //authBaseURI: 'http://192.168.1.172:8000/api-v1/auth',
        //appBaseURI: 'http://192.168.1.172:8000/api-v1/web-api/pos',
        //authBaseURI: 'https://gbl-dev.digibox-pos.com/api-v1/auth',
        //appBaseURI: 'https://gbl-dev.digibox-pos.com/api-v1/web-api/pos',
        authBaseURI: 'https://gbl-prod.digibox-pos.com/api-v1/auth',
        appBaseURI: 'https://gbl-prod.digibox-pos.com/api-v1/web-api/pos',
    };
    export default apiConfig;
</script>
